import { Tabs, TabsContent, TabsList, TabsTrigger } from "@repo/ui";
import { useState } from "react";

import { EditableItemDynamicTab } from "../../components/dynamicEditor/dynamicTab/editableItem";
import { useLocationContext } from "../../contexts/editableItemContext";
import { tabs } from "../../string";
import { Map } from "./map";
import { SiteVisitMap } from "./siteVisitMap";
import { StatusActionButtons } from "./statusButtons";
import { StatusHistory } from "./statusHistory";
import style from "./style.module.scss";

export function Summary() {
	const context = useLocationContext();
	const [activeTab, setActiveTab] = useState("history");
	return (
		<>
			<EditableItemDynamicTab
				itemContext={context}
				pageName={tabs.locationSummary}
				itemProp="location"
				updateValues={null}
				save={undefined}
				readonly
				loaded={context.locationLoaded}
				containerClass={style.detailsContainer}
			/>
			<StatusActionButtons />
			<Tabs value={activeTab} onValueChange={setActiveTab}>
				<TabsList>
					<TabsTrigger value="history">Status History</TabsTrigger>
					<TabsTrigger value="map">Map View</TabsTrigger>
					<TabsTrigger value="site-visit">Site Visits</TabsTrigger>
				</TabsList>
				<TabsContent value="history">
					<StatusHistory />
				</TabsContent>
				<TabsContent value="map">
					<Map />
				</TabsContent>
				<TabsContent value="site-visit">
					<SiteVisitMap />
				</TabsContent>
			</Tabs>
		</>
	);
}
